import React from 'react';
import { tickerEvents } from '../data/tickerEvents';
import type { TickerEvent } from '../data/tickerEvents';
const dot: Record<TickerEvent['state'], string> = {
  ok: 'bg-healthy-bright',
  warn: 'bg-warn-bright',
  down: 'bg-critical-bright',
  sent: 'bg-brand-bright'
};
function Row({
  event
}: {
  event: TickerEvent;
}) {
  return <span className="flex shrink-0 items-center gap-2.5 px-5" data-id="element-348" data-mp="3v6kpycbze9i9">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot[event.state]}`} aria-hidden="true" data-id="element-349" data-mp="3q89ha4xfa51m" />
      <span className="font-mono text-[11px] text-white/40" data-id="element-350" data-mp="3m5mmbv5gg407">{event.time}</span>
      <span className="font-mono text-[11px] text-white/80" data-id="element-351" data-mp="3h6jfq69ttpq4">
        {event.domain}
      </span>
      <span className="font-mono text-[11px] text-white/45" data-id="element-352" data-mp="3c91fr5dseku9">
        {event.detail}
      </span>
    </span>;
}

/**
 * The scheduler's morning, running past. Continuous motion, so it uses a
 * linear loop and pauses on hover for anyone trying to read it.
 */
export function LiveTicker() {
  return <div className="marquee relative flex items-center border-y border-shell-line bg-shell-raised/60" data-id="element-353" data-mp="1cy0j02vs1krf">
      <span className="z-10 flex shrink-0 items-center gap-2 border-r border-shell-line bg-shell px-4 py-2.5" data-id="element-354" data-mp="1h0wwjf6gmqoi">
        <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-healthy-bright" data-id="element-355" data-mp="131e03jn0h3s1" />
        <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-white/60" data-id="element-356" data-mp="17ydxz79pj082">
          live
        </span>
      </span>

      <div className="flex min-w-0 flex-1 overflow-hidden py-2.5" role="log" aria-label="Recent monitoring checks" data-id="element-357" data-mp="1vpjmsbxml2ui">
        <div className="marquee-track flex w-max shrink-0 items-center" data-id="element-358" data-mp="1lzgkfl4m6cji">
          {[...tickerEvents, ...tickerEvents].map((event, index) => <Row key={`${event.time}-${index}`} event={event} data-id="element-359" data-mp="1qwgr9y9afjbo" data-mpi={index} />)}
        </div>
      </div>
    </div>;
}